import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import { Button, Col, Form, Input, Row, Typography } from 'antd';
import { ExclamationCircleFilled, CloseOutlined } from "@ant-design/icons";
import { useForm } from 'antd/es/form/Form';
import "./login.scss";

const SignIn = () => {

    const [loginform] = useForm();
    const navigate = useNavigate();

    const [aunthenticationloading, setAuthenticationLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const handleSignIn = async () => {
        setAuthenticationLoading(true);
        setError('');
        try {
            const user = await Auth.signIn(username, password);
            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                await Auth.completeNewPassword(user, password);
            }
            navigate('/artwork');
            window.location.reload();
        } catch (error: any) {
            setError(error.message || 'Error signing in');
            console.log("Login error: ", error);
        } finally {
            setAuthenticationLoading(false);
        }
    };

    return (
        <div className="signin-container">
            <Row style={{ minHeight: '100vh' }}>
                {/* Left Side - Branding */}
                <Col xs={0} md={12} className="left-side">
                    <div className="branding-content">
                        <h1 className="brand-title">NeXPyn</h1>
                        <div className="tagline">
                            <h2>New Technology</h2>
                            <h2>for the <span className="art-world">Art World</span></h2>
                        </div>
                    </div>
                </Col>

                {/* Right Side - Login Form */}
                <Col xs={24} md={12} className="right-side">
                    <div className="login-form-container">
                        <div className="login-form-content">
                            <div className="mobile-brand">NeXPyn</div>
                            <Typography.Title level={2} className="login-title">Login</Typography.Title>

                            <Form
                                layout="vertical"
                                className="login-form"
                                form={loginform}
                                onFinish={handleSignIn}
                                requiredMark={false}
                            >
                                <Form.Item
                                    label="Email"
                                    name="email"
                                    rules={[{
                                        required: true,
                                        message: "Please enter your email!"
                                    }]}
                                >
                                    <Input
                                        placeholder="Enter your email"
                                        size="large"
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Password"
                                    name="password"
                                    rules={[{
                                        required: true,
                                        message: "Please enter your password!"
                                    }]}
                                >
                                    <Input.Password
                                        placeholder="Enter your password"
                                        size="large"
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </Form.Item>

                                {error && (
                                    <Row style={{background:'#f5bcbc',paddingInline:5,paddingBlock:10, marginBottom: 16}}>
                                        <Col span={2} push={1}><ExclamationCircleFilled style={{color:'#7e3536'}}/></Col>
                                        <Col span={14} push={1} style={{color:'#ef3c3e'}}>{error}</Col>
                                        <Col span={3} onClick={() => setError("")}><CloseOutlined style={{color:'#7e3536'}}/></Col>
                                    </Row>
                                )}

                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="login-button"
                                    loading={aunthenticationloading}
                                    disabled={aunthenticationloading}
                                    block
                                >
                                    Login
                                </Button>
                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default SignIn;